
import dayjs from "dayjs"

export const clearFilterData = {
  TukId: null,
  SpId: null,
  ChgDteSt: null,
  ChgDteEn: null,
}

export const initFilterData = {
  ...clearFilterData,
}

export const initOilChangeDialogData = {
  TukId: null,
  SpId: null,
  ChgDte: dayjs().format("YYYY-MM-DD"),
  Mileage: null,
  Qty: 0,
  UntPr: 0,
  TotalPr: 0,
  NxtMileage: null,
  MileageIntv: null,
  NxtDte: null,
  DteIntv: null,
  SupId: null,
  DocNo: "",
  DocDte: null,
  Dscp: "",
  Rmk: "",
}
